"use client";

import * as React from "react";
import { Field, Input, HStack, Button } from "@chakra-ui/react";
import useControllable from "hooks/useControllable/useControllable";

export interface PasswordFieldProps {
  id: string;
  label?: string;
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  required?: boolean;
  helperText?: string;
  error?: string;
  onChange?: (value: string) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const PasswordField: React.FC<PasswordFieldProps> = (props) => {
  const { id, label, placeholder, required, helperText, error, onBlur } = props;

  const [value, setValue] = useControllable<string>({
    value: props.value,
    defaultValue: props.defaultValue ?? "",
    onChange: props.onChange,
  });

  const [show, setShow] = React.useState(false);

  return (
    <Field.Root invalid={!!error} required={!!required}>
      {label && (
        <Field.Label>
          {label}
          {required && <Field.RequiredIndicator />}
        </Field.Label>
      )}

      <HStack>
        <Input
          id={id}
          name={id}
          type={show ? "text" : "password"}
          value={value}
          placeholder={placeholder}
          onChange={(e) => setValue(e.target.value)}
          onBlur={onBlur}
        />
        <Button
          size="sm"
          variant="ghost"
          onClick={() => setShow((s) => !s)}
          aria-label={show ? "Hide password" : "Show password"}
        >
          {show ? "Hide" : "Show"}
        </Button>
      </HStack>

      {error ? (
        <Field.ErrorText>{error}</Field.ErrorText>
      ) : helperText ? (
        <Field.HelperText>{helperText}</Field.HelperText>
      ) : null}
    </Field.Root>
  );
};
